import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import {
    Typography,
    Container,
    Dialog,
    Grid,
    TextField,
    RadioGroup,
    Radio,
    FormControlLabel,
} from "@material-ui/core";
import { CommonStyles } from "../../commons/CommonStyles";
import { DialogStyles } from "../CommonComponents/Dialogs/DialogStyles";
import { checkIsNullUndefined, decode64, encode64, getErrorMessage, getScreenWidth } from "../../commons/Utils";
import {
    DeleteVerificationUserPhone,
    PostProfileUserOnlyPhone,
    PostVerificationDataPhone,
    PostVerificationSendPhone,
} from "../../services/ReasonService";
import { useTranslation } from "react-i18next";
import { CorreosButton } from "../CorreosButton/CorreosButton";
import { PostApplicationAuxSSOLogin } from "../../services/ApplicationAuxCallsService";
import { Constants } from "../../commons/Constants";
import { backToLogin, setUserSession } from "../../services/Commons";
import ReCAPTCHA from "react-google-recaptcha";
import { BasicDialog } from "../CommonComponents/BasicDialog";

export function DialogOnePhone(props) {
    const { open, auxUser, userPhones, tokenResult, finishOperation, managePath, countryList } = props;
    const commonClasses = CommonStyles();
    const dialogClasses = DialogStyles();
    const cookies = new Cookies();
    const { t, i18n } = useTranslation();

    const [phoneOriginalList, setPhoneOriginalList] = useState([]);
    const [phoneList, setPhoneList] = useState([]);
    const [phone, setPhone] = useState("");
    const [sending, setSending] = useState(false);
    const [working, setWorking] = useState(false);
    const [sended, setSended] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState(false);
    const [otpErrorText, setOtpErrorText] = useState("");
    const [notVerified, setNotVerified] = useState(false);
    const [reCaptchaToken, setReCaptchaToken] = useState(null);
    const [reCaptchaError, setReCaptchaError] = useState("");
    const [reCaptchaRef, setReCaptchaRef] = useState(null);
    const [openNoPhoneModal, setOpenNoPhoneModal] = useState(false);

    useEffect(() => {
        setPhoneOriginalList(JSON.parse(JSON.stringify(userPhones)));
        let auxList = userPhones.map(phone => countryList.find(country => country.id == phone.idCountry)?.phonePrefix + "-" + phone.phone);
        setPhoneList(auxList);
        let auxValue = auxList.find(phone => phone === auxUser);
        let defaultPhone = checkIsNullUndefined(auxValue) ? auxList[0] : auxValue;
        setPhone(defaultPhone);
        checkVerifiedPhone(defaultPhone);
    }, [open, userPhones, auxUser]);

    const handleChangeOtp = (value) => {
        const re = /^[0-9\b]{1,12}$/;
        if (value === "" || re.test(value)) {
            setOtp(value);
        };
    };

    const handleChangePhone = (value) => {
        checkVerifiedPhone(value);
        setPhone(value);
    };

    const checkVerifiedPhone = (value) => {
        let phoneNumber = value?.split("-")[1];
        let auxPhone = phoneOriginalList.find(phones => phones.phone == phoneNumber);
        setNotVerified(auxPhone?.idConTypeVerification < 5);
    };

    const mountForm = () => {
        return (
            <Grid item xs={12}>
                <Typography>
                    <strong>{t("loginSelectOnePhoneSelect")}</strong>
                </Typography>
                <RadioGroup
                    defaultValue={phone}
                    value={phone}
                    onChange={(e) => handleChangePhone(e.target.value)} style={{ marginLeft: "1em" }}>
                    {phoneList.map((auxPhone) => {
                        return (
                            <FormControlLabel key={auxPhone} value={auxPhone} control={<Radio />} label={auxPhone} style={{ marginBottom: "-0.5em" }} />
                        )

                    })}
                </RadioGroup>
            </Grid>
        );
    };

    const checkDisabledConfirm = () => {
        return (notVerified && !sended) && (checkIsNullUndefined(otp) || otpError || sending);
    };

    const handleConfirm = () => {
        setWorking(true);
        if (notVerified) {
            handleVerifyOtp();
        } else {
            handleDeletePhones();
        };
    };

    const handleDeletePhones = async () => {
        await PostProfileUserOnlyPhone(phone);
        checkLastStep();
    };

    const handleSendOtp = async () => {
        setSending(true);
        let auxError = false;
        let auxErrorText = "";
        let auxSended = false;
        let response = await PostVerificationSendPhone(phone, reCaptchaToken);
        if (response && !response.Status) {
            auxSended = true;
        } else {
            auxError = true;
            auxErrorText = getErrorMessage(response);
        };
        reCaptchaRef?.reset();
        setReCaptchaToken(null);
        setOtpError(auxError);
        setOtpErrorText(auxErrorText);
        setSending(false);
        setSended(auxSended);
    };

    const handleVerifyOtp = async () => {

        let response = await PostVerificationDataPhone(phone, otp);
        if (response && !response.Status) {
            handleDeletePhones();
        } else {
            finishOperation("error", getErrorMessage(response));
            setWorking(false);
        };
    };

    const checkLastStep = async () => {
        if ((!auxUser.includes("@")) && (phone != auxUser)) {
            let sessionCookie = cookies.get(Constants.cookieValue);
            let auxCookie = decode64(sessionCookie);
            let encodedCookie = encode64(auxCookie.IdCookie);
            let response = await PostApplicationAuxSSOLogin(encodedCookie);
            if (response && (!response.Status || response.Status < 400)) {
                setUserSession(response, i18n, null).then(() => {
                    managePath(response, auxUser);
                });
            } else {
                finishOperation("error", getErrorMessage(response));
                backToLogin();
            };
        } else {
            managePath(tokenResult, auxUser);
        };
    };

    const handleOnChangeReCaptcha = (value) => {
        let auxRecaptchaToken = checkIsNullUndefined(value) ? null : value;
        if (!checkIsNullUndefined(value)) {
            setReCaptchaError("");
        };
        setReCaptchaToken(auxRecaptchaToken);
    };

    const handleOpenNoPhoneModal = () => {
        setOpenNoPhoneModal(true);
    };

    const handleConfirmNoPhoneModal = (phoneList) => {
        //Función para borrar los teléfonos del usuario y continuar con el proceso de login.
        let auxPhone = phoneList[0];
        setWorking(true);
        DeleteVerificationUserPhone(auxPhone)
            .then(() => {
                let newPhoneList = phoneList.filter(phone => phone != auxPhone);
                if (newPhoneList.length > 0) {
                    handleConfirmNoPhoneModal(newPhoneList);
                } else {
                    setWorking(false);
                    checkLastStep();
                }
            });
    };

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            PaperProps={{ classes: { root: dialogClasses.dialogWindow } }}
        >
            <>
                <Container className={dialogClasses.dialogTitle}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h4" className={dialogClasses.dialogTitleText}>
                                {t("loginSelectOnePhoneTitle")}
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
                <Container className={dialogClasses.dialogContainer}>
                    <Grid container item xs={12} className={commonClasses.gridIdentity}>
                        <Grid item xs={12} style={{ marginBottom: "1em" }}>
                            <Typography className={commonClasses.dialogContentText}>
                                {t("loginSelectOnePhoneText")}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={1}>
                        {mountForm()}
                        {notVerified && (
                            <Grid container item xs={12} className={commonClasses.gridIdentity}>
                                <Grid item xs={12} style={{ marginBottom: "1em" }}>
                                    <Typography className={commonClasses.dialogContentText}>
                                        {t("loginSelectOnePhoneNotVerified")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <TextField
                                        color="secondary"
                                        defaultValue={otp}
                                        value={otp}
                                        onChange={(value) => handleChangeOtp(value.target.value)}
                                        variant="filled"
                                        fullWidth
                                        name="otp"
                                        autoFocus
                                        label={t("login2FASetPhoneOtp")}
                                        type="text"
                                        error={otpError}
                                        helperText={otpErrorText}
                                        required
                                        className={commonClasses.inputsStyle}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <CorreosButton
                                        color={sended ? "secondary" : "primary"}
                                        variant={sended ? "outlined" : "contained"}
                                        onClick={() => handleSendOtp()}
                                        disabled={working || checkIsNullUndefined(reCaptchaToken)}
                                        circularProgress={sending}
                                    >
                                        {sended ? t("reSend") : t("send")}
                                    </CorreosButton>
                                </Grid>
                                <Grid
                                    item
                                    container
                                    justifyContent="center"
                                    xs={12}
                                    className={commonClasses.gridIdentity}
                                    style={{ marginBottom: "1em" }}
                                >
                                    <Grid style={{ display: 'inline-block', marginTop: '2em' }}>
                                        <ReCAPTCHA
                                            ref={(r) => setReCaptchaRef(r)}
                                            sitekey={process?.env?.REACT_APP_RECAPTCHA_KEY}
                                            onChange={handleOnChangeReCaptcha}
                                            size={getScreenWidth() > 440 ? "normal" : "compact"} />

                                        {checkIsNullUndefined(reCaptchaError) ? null : (
                                            <p style={{ color: "#f32735", fontSize: "80% !important", textAlign: "start" }}>{reCaptchaError}</p>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>

                        )}
                        <Grid
                            item
                            container
                            xs={12}
                            className={dialogClasses.dialogButtonContainer}
                        >
                            <Grid item xs={6} style={{ display: "flex" }}>
                                <CorreosButton
                                    variant="contained"
                                    color="primary"
                                    onClick={handleOpenNoPhoneModal}
                                    className={dialogClasses.dialogButtonLeft}
                                    disabled={false}
                                    circularProgress={working}
                                >
                                    {t("loginSelectOnePhoneNoPhones")}
                                </CorreosButton>
                            </Grid>
                            <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                                <CorreosButton
                                    variant="contained"
                                    color="primary"
                                    onClick={handleConfirm}
                                    className={dialogClasses.dialogButtonRight}
                                    disabled={checkDisabledConfirm()}
                                    circularProgress={working}
                                >
                                    {t("confirm")}
                                </CorreosButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </>
            <BasicDialog
                open={openNoPhoneModal}
                setOpen={setOpenNoPhoneModal}
                title={t("loginSelectOnePhoneNoPhonesTitle")}
                text={t("loginSelectOnePhoneNoPhonesText")}
                action={() => handleConfirmNoPhoneModal(phoneList)}
                circularProgress={working}
            />
        </Dialog>
    );
}
